/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigurationType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type SuggestionActionResultType = "Autopilot" | "ConfigureSettings" | "Decline" | "Fyi" | "Invite" | "RemoveAttendee" | "RequestToMove" | "Reschedule" | "ViewMeeting" | "ViewProfile" | "ViewTeamDashboard" | "%future added value";
export type TipType = "CheckOutProfile" | "CheckOutRescheduler" | "CheckOutTeamDashboard" | "FeedWelcome" | "%future added value";
export type SuggestionAction_feedSuggestion = {
    readonly id: string;
    readonly suggestionPayload: ({
        readonly __typename: "SuggestionResultChromeExtensionTipPayload";
        readonly tipType: TipType | null;
    } | {
        readonly __typename: "SuggestionResultMissingUserConfigurationPayload";
        readonly configurationType: ConfigurationType | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly primaryAction: {
        readonly display: string | null;
        readonly isPrimary: boolean | null;
        readonly type: SuggestionActionResultType | null;
        readonly payload: ({
            readonly __typename: "SuggestionActionAutopilotPayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionAutopilot_payload">;
        } | {
            readonly __typename: "SuggestionActionConfigureSettingsPayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionConfigSettings_payload">;
        } | {
            readonly __typename: "SuggestionActionDeclinePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionDecline_payload">;
        } | {
            readonly __typename: "SuggestionActionFyiPayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionFyi_payload">;
        } | {
            readonly __typename: "SuggestionActionInvitePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionInvite_payload">;
        } | {
            readonly __typename: "SuggestionActionRemoveAttendeePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionRemoveAttendee_payload">;
        } | {
            readonly __typename: "SuggestionActionRequestToMovePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionRequestToMove_payload">;
        } | {
            readonly __typename: "SuggestionActionReschedulePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionReschedule_payload">;
        } | {
            readonly __typename: "SuggestionActionViewMeetingPayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionViewMeeting_payload">;
        } | {
            readonly __typename: "SuggestionActionViewProfilePayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionViewProfile_payload">;
        } | {
            readonly __typename: "SuggestionActionViewTeamDashboardPayload";
            readonly " $fragmentRefs": FragmentRefs<"SuggestionActionViewTeamDashboard_payload">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
    } | null;
    readonly " $refType": "SuggestionAction_feedSuggestion";
};
export type SuggestionAction_feedSuggestion$data = SuggestionAction_feedSuggestion;
export type SuggestionAction_feedSuggestion$key = {
    readonly " $data"?: SuggestionAction_feedSuggestion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionAction_feedSuggestion">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionAction_feedSuggestion",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestionPayload",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tipType",
                                "storageKey": null
                            }
                        ],
                        "type": "SuggestionResultChromeExtensionTipPayload",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "configurationType",
                                "storageKey": null
                            }
                        ],
                        "type": "SuggestionResultMissingUserConfigurationPayload",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "SuggestionActionResult",
                "kind": "LinkedField",
                "name": "primaryAction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "display",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPrimary",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "payload",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionAutopilot_payload"
                                    }
                                ],
                                "type": "SuggestionActionAutopilotPayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionConfigSettings_payload"
                                    }
                                ],
                                "type": "SuggestionActionConfigureSettingsPayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionDecline_payload"
                                    }
                                ],
                                "type": "SuggestionActionDeclinePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionFyi_payload"
                                    }
                                ],
                                "type": "SuggestionActionFyiPayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionInvite_payload"
                                    }
                                ],
                                "type": "SuggestionActionInvitePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionRemoveAttendee_payload"
                                    }
                                ],
                                "type": "SuggestionActionRemoveAttendeePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionRequestToMove_payload"
                                    }
                                ],
                                "type": "SuggestionActionRequestToMovePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionReschedule_payload"
                                    }
                                ],
                                "type": "SuggestionActionReschedulePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionViewMeeting_payload"
                                    }
                                ],
                                "type": "SuggestionActionViewMeetingPayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionViewProfile_payload"
                                    }
                                ],
                                "type": "SuggestionActionViewProfilePayload",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SuggestionActionViewTeamDashboard_payload"
                                    }
                                ],
                                "type": "SuggestionActionViewTeamDashboardPayload",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "FeedSuggestion",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '093927b9be71995489cb09a54b2fffaf';
export default node;
